import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card, CardContent } from '../../components/ui/card';
import { toast } from 'sonner';
import { providerApi } from '../../lib/providerApi';

export default function ProviderAuthPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login'); // login | register
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: '', password: '', company_name: '', contact_name: '', address: '', vat_id: '', claim_provider_id: '',
  });

  const setField = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === 'login') {
        const res = await providerApi.login(form.email, form.password);
        localStorage.setItem('provider_token', res.token);
        toast.success('Willkommen zurück!');
        navigate('/provider/dashboard');
      } else {
        const res = await providerApi.register(form);
        toast.success(res.message || 'Registrierung erfolgreich');
        setMode('login');
      }
    } catch (err) {
      toast.error(err.message || 'Fehler');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-semibold text-slate-900" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
            Provider-Portal
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            {mode === 'login' ? 'Melden Sie sich an' : 'Registrieren Sie sich als Anbieter'}
          </p>
        </div>

        <Card className="rounded-2xl">
          <CardContent className="p-6">
            <div className="flex gap-2 mb-6">
              <Button type="button" variant={mode === 'login' ? 'default' : 'outline'} size="sm" className="flex-1" onClick={() => setMode('login')}>
                Login
              </Button>
              <Button type="button" variant={mode === 'register' ? 'default' : 'outline'} size="sm" className="flex-1" onClick={() => setMode('register')}>
                Registrieren
              </Button>
            </div>

            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>E-Mail</Label>
                <Input type="email" required value={form.email} onChange={e => setField('email', e.target.value)} />
              </div>
              <div>
                <Label>Passwort</Label>
                <Input type="password" required value={form.password} onChange={e => setField('password', e.target.value)} />
              </div>

              {mode === 'register' && (
                <>
                  <div>
                    <Label>Firmenname</Label>
                    <Input required value={form.company_name} onChange={e => setField('company_name', e.target.value)} />
                  </div>
                  <div>
                    <Label>Ansprechpartner</Label>
                    <Input value={form.contact_name} onChange={e => setField('contact_name', e.target.value)} />
                  </div>
                  <div>
                    <Label>Anschrift</Label>
                    <Input value={form.address} onChange={e => setField('address', e.target.value)} />
                  </div>
                  <div>
                    <Label>USt-ID (optional)</Label>
                    <Input value={form.vat_id} onChange={e => setField('vat_id', e.target.value)} />
                  </div>
                  <div>
                    <Label>„Ich bin der Provider" – Provider-ID (optional)</Label>
                    <Input placeholder="z.B. aus dem Admin-Bereich / bei uns gelistete ID" value={form.claim_provider_id} onChange={e => setField('claim_provider_id', e.target.value)} />
                    <p className="text-[11px] text-muted-foreground mt-1">
                      Falls Sie bereits in unserer Liste geführt werden, geben Sie hier die ID an – Ihre vorhandenen
                      Preisdaten werden übernommen. Wir prüfen und schalten frei.
                    </p>
                  </div>
                </>
              )}

              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? 'Bitte warten...' : mode === 'login' ? 'Anmelden' : 'Registrieren'}
              </Button>
            </form>

            <p className="text-center text-xs text-muted-foreground mt-4">
              <Link to="/" className="text-sky-600 hover:text-sky-700">← Zurück zur Startseite</Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
